/**
 * ObstacleRenderer - Renders wall obstacles on the stage.
 *
 * Direct port from bumblebee ObstacleRenderer.
 *
 * @see GitHub Issue #852
 */

export default class ObstacleRenderer {
    /**
     * @param {HTMLElement} stage - Stage element
     * @param {Array} obstacles - [{x, y, width, height}]
     */
    constructor (stage, obstacles) {
        this._stage = stage;
        this._elements = [];

        for (const obs of obstacles) {
            const el = document.createElement('div');
            el.className = 'activity-obstacle';
            el.style.left = `${obs.x}px`;
            el.style.top = `${obs.y}px`;
            el.style.width = `${obs.width}px`;
            el.style.height = `${obs.height}px`;
            this._stage.appendChild(el);
            this._elements.push(el);
        }
    }

    destroy () {
        for (const el of this._elements) {
            if (el.parentNode) el.parentNode.removeChild(el);
        }
        this._elements = [];
    }
}
